// extracted by mini-css-extract-plugin
export var heroImg = "hero-module--heroImg--34oLA";
export var heroImgWrapper = "hero-module--heroImgWrapper--1fxRF";
export var zoomingHeroImg = "hero-module--zoomingHeroImg--3xEZx";
export var zoom = "hero-module--zoom--28gb-";